<div class="flex flex-col p-6" *ngIf="vm$ | async as vm">
	<div class="flex justify-center">
		<img
			class="w-1/5"
			src="/assets/images/leap/matter-lawyer-clerk-mapping.png"
			alt="Matter lawyer or clerk alert"
		/>
	</div>
	<div class="flex justify-center mt-8">
		<h1 class="text-3xl font-medium">
			The
			<span *ngIf="vm.displayMode === DisplayMode.LAWYERS_ONLY">Lawyer</span>
			<span *ngIf="vm.displayMode === DisplayMode.CLERKS_ONLY">Clerk</span>
			<span *ngIf="vm.displayMode === DisplayMode.BOTH">Lawyer And Clerk</span>
			in LEAP and Closer do not match
		</h1>
	</div>
	<div class="flex justify-center gap-4">
		<ui-section
			*ngIf="
				vm.displayMode === DisplayMode.LAWYERS_ONLY ||
				vm.displayMode === DisplayMode.BOTH
			"
			class="h-full w-5/12"
			title="Lawyer"
			type="section"
		>
			<div
				section-content
				class="grid grid-rows-fit-content grid-cols-[1fr_4fr] gap-x-5 gap-y-4"
			>
				<div class="text-sm font-medium">LEAP</div>
				<div class="text-sm">{{ vm.mismatchedLawyers.leapLawyerName }}</div>

				<div class="text-sm font-medium">Closer</div>
				<div class="text-sm">{{ vm.mismatchedLawyers.closerLawyerName }}</div>
			</div>
		</ui-section>

		<ui-section
			*ngIf="
				vm.displayMode === DisplayMode.CLERKS_ONLY ||
				vm.displayMode === DisplayMode.BOTH
			"
			class="h-full w-5/12"
			title="Clerk"
			type="section"
		>
			<div
				section-content
				class="grid grid-rows-fit-content grid-cols-[1fr_4fr] gap-x-5 gap-y-4"
			>
				<div class="text-sm font-medium">LEAP</div>
				<div class="text-sm">{{ vm.mismatchedClerks.leapClerkName }}</div>

				<div class="text-sm font-medium">Closer</div>
				<div class="text-sm">{{ vm.mismatchedClerks.closerClerkName }}</div>
			</div>
		</ui-section>
	</div>
	<div class="flex justify-center mt-4">
		Would you like to update the Closer matter to reflect the&nbsp;
		<span *ngIf="vm.displayMode === DisplayMode.LAWYERS_ONLY">lawyer</span>
		<span *ngIf="vm.displayMode === DisplayMode.CLERKS_ONLY">clerk</span>
		<span *ngIf="vm.displayMode === DisplayMode.BOTH">lawyer and clerk</span>
		&nbsp;in LEAP?
	</div>
	<div class="flex justify-center gap-4 mt-8">
		<ui-button
			preset="MEDIUM_EMPHASIS"
			label="Don't Update"
			(click)="closeDialog(ResolveMismatchOption.NO_UPDATE)"
		></ui-button>
		<ui-button
			preset="HIGH_EMPHASIS"
			label="Update Now"
			(click)="closeDialog(ResolveMismatchOption.UPDATE)"
		></ui-button>
	</div>
</div>
